import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Row from './Row';
import Pagination from "react-js-pagination";
import MyPagination from "../../common/Pagination";
import DatePicker from 'react-date-picker';
import { DateRange } from 'react-date-range';
import moment from 'moment';

export default class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataShow: [],
            filterText: '',
            activePage: 1,
            itemsCountPerPage: 100,
            totalItemsCount: 0,
            columnSort: location.search.indexOf("sort_column=") > -1 ? new URLSearchParams(location.search).get('sort_column') : '',
            typeSort: location.search.indexOf("sort_type=") > -1 ? new URLSearchParams(location.search).get('sort_type') : 1,
            date: new Date(),
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            rangeDateStr:''
        };
        if(this.props.hasOwnProperty('startDate') && this.props.hasOwnProperty('endDate')){
            this.state.rangeDateStr= this.props.startDate.format("YYYY-MM-DD") +'から'+this.props.endDate.format("YYYY-MM-DD")+'まで';
        }
        this.handleFilterTextInput = this.handleFilterTextInput.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleCountPerPageChange = this.handleCountPerPageChange.bind(this);
        //this.handleSortData = this.handleSortData.bind(this);
        this.handleSortAllData = this.handleSortAllData.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.compare = this.compare.bind(this);
        this.searchColumn = this.searchColumn.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.handleSearchByPage = this.handleSearchByPage.bind(this);
        this.handleRangeChange = this.handleRangeChange.bind(this);
        this.handleSearchDataByRange = this.handleSearchDataByRange.bind(this);
        this.handleSendMail = this.handleSendMail.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.renderDownloadBtn = this.renderDownloadBtn.bind(this);
        this.handleChangeCheckBoxBulkCopy = this.handleChangeCheckBoxBulkCopy.bind(this);
        this.handleBulkCopy = this.handleBulkCopy.bind(this);
    }
    /**
     * Call search data by date
     */
    handleSearchDataByRange(){
        if (typeof this.props.loadDataByRange === 'function') {
            this.props.loadDataByRange(this.state.startDate, this.state.endDate);
        }
    }
    /**
     * Listen change date
     */
    handleRangeChange(range) {
        this.setState({
           rangeDateStr : range.startDate.format("YYYY-MM-DD") +'から'+range.endDate.format("YYYY-MM-DD")+'まで',
           startDate: range.startDate,
           endDate: range.endDate
        });
    }
    /**
     * Listen change input data
     */
    onChangeDate(date) {
        this.setState({
            date: date
        });
        if (typeof this.props.loadDataByDate === 'function') {
            this.props.loadDataByDate(date);
        }
    }

    handleSearchByPage(searchConditions){
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchConditions);
        }
    }

    /**
     * Listen on click page
     */
    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        });
    }
    /**
     * Listen on input text filter table
     */
    handleFilterTextInput(filterText) {
        this.setState({
            filterText: filterText
        });
    }
    /**
     * Listen on change dropdown rows per page
     */
    handleCountPerPageChange(event) {
        this.setState({itemsCountPerPage: event.target.value});
    }
    /**
     * Listen on click sort on head of column
     * Sort all data in all pages
     */
    handleSortAllData(e) {
        let columnSort = '';
        if (e.target.getAttribute('column') == null){
            return;
        } else{
            columnSort = e.target.getAttribute('column');
            this.setState({
                columnSort: columnSort
            });
        }

        let typeSort = -1*e.target.getAttribute('data-sorttype');
        e.target.setAttribute('data-sorttype', typeSort);

        const sortForm = {
            sort_column: columnSort,
            sort_type: typeSort
        };
        if (typeof this.props.onSort === 'function') {
            this.props.onSort(sortForm);
        }
    }
    /**
     * Listen on click sort on head of column
     * Sort in view page by page
     */
    handleSortData(e) {
        if (e.target.getAttribute('column') == null)
            return;
        let typeSort = -1 * this.state.typeSort;
        this.setState({
            columnSort: this.state.columnSort = e.target.getAttribute('column'),
            typeSort: typeSort
        });
    }
    /**
     * Listen on click edit button
     */
    handleEdit(data) {
        if (typeof this.props.onEdit === 'function') {
            this.props.onEdit(data);
        }
    }

    /**
     * Listen on click view button
     */
    handleDetail(data) {
        if (typeof this.props.onDetail === 'function') {
            this.props.onDetail(data);
        }
    }

    /**
     * Listen on click send mail button
     */
    handleSendMail(data) {
        if (typeof this.props.onSendMail === 'function') {
            this.props.onSendMail(data);
        }
    }

    /**
     * Listen on click delete button
     */
    handleDelete(data) {
        if (typeof this.props.onDelete === 'function') {
            this.props.onDelete(data);
        }
    }
    /**
     * Listen on click delete button
     */
    handleAdd() {
        if (typeof this.props.onAdd === 'function') {
            this.props.onAdd();
        }
    }

    handleChangeCheckBoxBulkCopy(e,data) {
        if (typeof this.props.onChangeCheckBoxBulkCopy === 'function') {
            this.props.onChangeCheckBoxBulkCopy(e,data);
        }
    }
    handleBulkCopy() {
        if (typeof this.props.onBulkCopy === 'function') {
            this.props.onBulkCopy();
        }
    }
    /**
     *
     */
    getValueOfObject(val, names) {
        names = names.split('.');
        while (val && names.length) {
            val = val[ names.shift() ];
        }
        return val;
    }
    /**
     * Compare for function sort
     */
    compare(a, b) {
        var stringA = '', stringB = '';
        if (this.state.columnSort.indexOf('.') !== -1) {
            stringA = this.getValueOfObject(a, this.state.columnSort);
            stringB = this.getValueOfObject(b, this.state.columnSort);
        } else {
            stringA = a[this.state.columnSort];
            stringB = b[this.state.columnSort];
        }
        if (isNaN(stringA))
            return this.state.typeSort * stringA.localeCompare(stringB);
        else
            return this.state.typeSort * (stringA - stringB);

    }

    searchColumn(row) {
        var isSearched = this.state.filterText == '';
        this.props.header.map((item, i) => {
            if (item.isSearch === true) {
                var column = this.getValueOfObject(row, item.name);
                column = column ? column : '';
                isSearched = isSearched || column.toLowerCase().indexOf(this.state.filterText.toLowerCase()) !== -1
            }
        });
        return isSearched;
    }

    renderDownloadBtn() {
        if (this.props.hasOwnProperty("optionDownload")) {
            return (
              <button
                onClick={this.props.onDownload}
                className="btn bg-purple text-white"
              >
                CSVダウンロード
              </button>
            );
        }
        return;
    }

    render() {
        let pageShow = [], hasBtnSearch;
        if(!this.props.onSearch){
            this.state.dataShow = this.props.data.filter(this.searchColumn);
            hasBtnSearch = false;
        }else{
            this.state.dataShow = this.props.data;
            hasBtnSearch = true;
        }

        if (this.state.dataShow) {
            for (let i = (this.state.activePage - 1) * this.state.itemsCountPerPage; i < this.state.dataShow.length && i < this.state.activePage * this.state.itemsCountPerPage; i++) {
                pageShow.push(this.state.dataShow[i]);
            }
        }

        return (

            <React.Fragment>
                <table className="table table-stripped table-hover mb-0 table_responsive">
                    <thead className="thead-light">
                            <tr>
                            {this.props.header.map((item, i) =>{
                                if(item.type == 'checkbox_bulk_copy') {
                                return( <th onClick={this.handleBulkCopy} className={''} data-sorttype={this.state.typeSort} column={item.name} key={i}>
                                            <div class="btn btn-warning">{item.title}</div></th>)
                                } else {
                                return( <th onClick={item.isSort ? this.handleSortAllData : ()=>{}} className={item.isSort ? (this.state.columnSort == item.name ? 'isSort sorting' : 'isSort') : ''} data-sorttype={this.state.typeSort} column={item.name} key={i}>{item.title}
                                </th>)
                                }
                            }
                            )}
                            </tr>
                    </thead>
                    <tbody>
                        {pageShow.map((dataRow, i) => {
                            if(this.props.hasOwnProperty('optionTR')){
                                return <Row removeClick={this.props.removeClick} color={this.props.optionTR.colors[dataRow[this.props.optionTR.conditionColumn]]} onEdit={this.handleEdit} onDetail={this.handleDetail} onDelete={this.handleDelete} onChangeCheckBoxBulkCopy={this.handleChangeCheckBoxBulkCopy} key={i} data ={dataRow} header={this.props.header}/>;
                            }else{
                                return <Row color="" onSendMail={this.handleSendMail} removeClick={this.props.removeClick}  onEdit={this.handleEdit} onDetail={this.handleDetail} onDelete={this.handleDelete} key ={i} data ={dataRow} header={this.props.header}/>;
                            }
                        })}
                    </tbody>
                </table>
                <div className="card-footer">
                    { (this.props.hasOwnProperty('myPagination') && this.props.hasOwnProperty('searchConditions') && this.props.myPagination == 1) ? (
                        <div className="row">
                            <div className="col-sm-2">
                                {this.renderDownloadBtn()}
                            </div>
                            <div className="col-sm-8">
                                <nav>
                                    <MyPagination
                                        onSearch={this.handleSearchByPage}
                                        searchConditions={this.props.searchConditions}
                                        lastPage={this.props.lastPage}
                                        currentPage={this.props.currentPage}
                                        />
                                </nav>
                            </div>
                            <div className="col-sm-2 text-right">
                                <strong>{this.props.total}件中{this.props.from}から{this.props.to}まで表示</strong>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-sm-10">
                                <nav>
                                    <Pagination
                                        innerClass="pagination justify-content-center mb-0"
                                        activePage={this.state.activePage}
                                        itemClass="page-item"
                                        activeClass="active"
                                        activeLinkClass="page-link"
                                        linkClass="page-link"
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.dataShow.length}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange}
                                        />
                                </nav>
                            </div>
                            <div className="col-sm-2">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-white">表示</span>
                                    </div>
                                    <select className="form-control" onChange={this.handleCountPerPageChange} value={this.state.itemsCountPerPage}>
                                        <option>10</option>
                                        <option>20</option>
                                        <option>30</option>
                                        <option>50</option>
                                        <option>100</option>
                                    </select>
                                    <div className="input-group-append">
                                        <span className="input-group-text">件</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    }
                </div>
            </React.Fragment>
        );
    }
}
